import { useHealthblocksSWR } from '@healthblocks-io/core'
import { useRecoilValue } from 'recoil'

import { modeAtom } from './qa-mode'

export type FeatureFlag = keyof FeatureFlags
export type FeatureFlags = {
  awell_hosted_pages?: '1'
  care?: '1'
  care_question?: '1'
  health_parameters?: '1'
  medication_photo_parsing?: '1'
  message_banner_login?: string
  message_blocking?: string
  tenant_olvw?: '1'
}

export function useFeatureFlags() {
  const mode = useRecoilValue(modeAtom)
  return useHealthblocksSWR<FeatureFlags>('/feature-flags' + (mode === 'qa' ? '?mode=qa' : ''))
}

/**
 * Feature flags can depend on:
 * - actor (id/role)
 * - subject (id/role)
 * - time (before/after specified moment)
 * - device mode (qa/dev)
 * - project
 *
 * @returns Always a string, so it's possible to .split() or .includes() it.
 */
export function useFeatureFlag<K extends FeatureFlag, F extends FeatureFlags[K]>(key: K, fallback?: F | undefined) {
  const flags = useFeatureFlags()
  return flags.data?.[key] || fallback || ('' as const)
}
